import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { LimitPanel } from "../LimitPanel";
import { ProgressBar } from "../ProgressBar";
import { truncateNumber } from "../helpers";

interface StreamHoursProps {
  isLoading: boolean;
  limit: number;
  onPurchase: () => void;
  resetDate?: string;
  usage: number;
}

export const StreamHours = ({
  limit,
  usage,
  resetDate,
  onPurchase,
  isLoading,
}: StreamHoursProps) => {
  if (!limit) return null;

  const percentageUsed = (usage / limit) * 100;
  const tooltipText = resetDate
    ? t("live_streams.dashboard.limits.resets_on", {
        date: resetDate,
      })
    : undefined;

  return (
    <LimitPanel
      isLoading={isLoading}
      canPurchaseMore
      onPurchase={onPurchase}
      title={t("live_streams.dashboard.limits.hours_this_month")}
      tooltipText={tooltipText}
    >
      <div className="mb-5">
        <Typography.TitleMd>{truncateNumber(usage)}</Typography.TitleMd>
      </div>
      <ProgressBar
        usage={usage}
        limit={limit}
        label={t("live_streams.dashboard.limits.monthly_limit")}
        color={percentageUsed > 75 ? "red" : "green"}
      />
    </LimitPanel>
  );
};
